export const SET_SERVICE_LIST = 'SET_SERVICE_LIST';
export const SET_ADHOC_SERVICE_LIST = 'SET_ADHOC_SERVICE_LIST';